// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"fec9331f","227":"2ae96b79","453":"ba59fe97","580":"364cb93d"}[chunkId] + ".chunk.js";
};